import classNames from 'classnames/bind';
import Image from 'next/legacy/image';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './slider-box.module.scss';
import Button, { ButtonSize } from './../../../ui-kit/button/button';
import Icon, { IconTheme, IconVariant } from 'src/components/ui-kit/icon/icon';
import { Navigation } from 'src/entities/navigation';
import Link from 'next/link';

const classesContext = classNames.bind(styles);

export default function SliderBoxSlide({
  className,
  slide,
  ...restProps
}: {
  slide: Navigation;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  return (
    <div
      className={classesContext(['slider_main', className])}
      {...restProps}>
      <Image
        src={slide.linkImage}
        alt={slide.name}
        layout='fill'
        unoptimized
        priority
        blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='
        className={styles.slider_image}
      />
      <div className={styles.slider_content}>
        {slide.title && <h2 className={styles.slider_title}>{slide.title}</h2>}
        {slide.text && <p className={styles.slider_description}>{slide.text}</p>}
        {slide.btnText && (
          <div className={styles.slider_actions}>
            <Link href={slide.link}>
              <Button
                size={ButtonSize.LARGE}
                type='button'>
                {slide.btnText}&nbsp;
                <Icon
                  variant={IconVariant.ARROW}
                  theme={IconTheme.WHITE} />
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
